import { AnalysisActionType } from '@modules/analysis/types';
import { AnalysisBanner } from '@modules/common/components/AnalysisBanner';
import { decompressURLSearchParams } from '@modules/common/utils';

export const useHandleQuantifyBanner = (actionType: AnalysisActionType) => {
  const searchParams = new URLSearchParams(
    decompressURLSearchParams(window.location.search),
  );

  const shouldShowGlobalFilters =
    searchParams.get('showGlobalFilters') === 'true';

  if (actionType === AnalysisActionType.SAVE_AS && shouldShowGlobalFilters) {
    return (
      <AnalysisBanner>
        Dashboard filters applied. This Quantify wasn't created by you, edits
        can be saved as a new Quantify.
      </AnalysisBanner>
    );
  }

  if (actionType === AnalysisActionType.SAVE_AS) {
    return (
      <AnalysisBanner>
        This Quantify wasn't created by you, edits can be saved as a new
        Quantify.
      </AnalysisBanner>
    );
  }

  if (shouldShowGlobalFilters) {
    return <AnalysisBanner>Dashboard filters applied.</AnalysisBanner>;
  }

  return null;
};
